module.exports = __webpack_public_path__ + "img/b-medal-copper.f7eee795.png";